/* eslint-disable */
<template>
  <div id="admin-snapshot">
    <div class="admin-header mb-3">
      <v-btn
        v-if="!showHeaderData"
        depressed
        block
        class="no-height-limit"
        color="grey lighten-3"
        @click="getHeaderData"
      >
        <v-layout
          justify-center
          align-center
          column
          py-3
        >
          <v-icon
            :size="64"
          >
            table_chart
          </v-icon>
          <h3
            class="display-1"
          >
            Load aggregate data
          </h3>
        </v-layout>
      </v-btn>
      <div v-else>
        <v-container v-if="headerDataLoading" class="loader-snapshot-header column">
          <v-progress-circular indeterminate size=70 :width="5"></v-progress-circular>
          <div class="headline mt-3">Loading aggregate data...</div>
        </v-container>
        <div class="admin-row-center" v-if="!headerDataLoading">
          <v-card  width="200" height="100" style="background-color:#fff !important;" class="snapshot-card">
            <div>
              <v-icon large style="margin-right: 12px;">person</v-icon>
              <span>{{headerData.instructors.toLocaleString('en')}}</span>
            </div>
            <h4>All-time Instructors</h4>
          </v-card>
          <v-card  width="200" height="100" style="background-color:#fff !important;" class="snapshot-card">
            <div>
              <v-icon large style="margin-right: 12px;">people</v-icon>
              <span>{{headerData.students.toLocaleString('en')}}</span>
            </div>
            <h4>Active Students</h4>
          </v-card>
          <v-card  width="200" height="100" style="background-color:#fff !important;" class="snapshot-card">
            <div>
              <v-icon large style="margin-right: 12px;">lightbulb</v-icon>
              <span>{{headerData.bulbs.toLocaleString('en')}}</span>
            </div>
            <h4>All-time Bulbs Built</h4>
          </v-card>
          <v-card  width="200" height="100" style="background-color:#fff !important;" class="snapshot-card" v-if="adminData.hosting && !adminData.hasLimitedVideoUploadAccess">
            <div>
              <v-icon large style="margin-right: 12px;">video_library</v-icon>
              <span>{{parseInt(headerData.minutes).toLocaleString('en')}}</span>
            </div>
            <h4>HLS Video Uploaded (min)*</h4>
          </v-card>
          <div style="position:relative; top:90; right:0">
            <v-menu
                :disabled="graphDataLoading || listDataLoading"
                v-model="popoverToggles.snapshot"
                :close-on-content-click="false"
                :nudge-width="530"
                :nudge-left="575"
                attach="#snapshotbutton"
                lazy
              >
              <v-btn icon  slot="activator" class="branded-text">
                <v-icon :disabled="graphDataLoading || listDataLoading">settings</v-icon>
              </v-btn>
              <Popover
                id="dash-popovers"
                tabindex="-1"
                v-if="popoverToggles.snapshot"
                type="snapshot">
              </Popover>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <v-layout px-4>
      <v-layout class="admin-data-column" pr-2>
        <div
          style="height: 415px; width: 100%"
          v-if="!showGraphData"
        >
          <v-btn
            depressed
            block
            class="full-height"
            color="grey lighten-3"
            @click="getGraphData"
          >
            <v-layout
              justify-center
              align-center
              column
              py-3
            >
              <v-icon
                :size="64"
              >
                insert_chart_outlined
              </v-icon>
              <h3
                class="display-1"
              >
                Load graph data
              </h3>
            </v-layout>
          </v-btn>
        </div>
        <div style="width: 100%" v-else>
          <v-layout
            justify-center
            align-center
            style="height:415px; width: 100%"
            v-if="graphDataLoading"
            column
          >
            <v-progress-circular indeterminate size=70 :width="5"></v-progress-circular>
            <div class="headline mt-3">Loading graph data...</div>
          </v-layout>
          <div v-else>
            <div style=" height:415px; padding-top:18px;">
              <h1 class="admin-snapshot-header">Student Engagement (hours)</h1>
              <div style="padding-top:12px;">
                <line-chart  id="engagement" :chart-data="engagementSnapshot.student"></line-chart>
              </div>
            </div>
            <div style=" height:415px; padding-top:18px;">
              <h1 class="admin-snapshot-header">Bulbs Delivered</h1>
              <div style="padding-top:12px;">
                <line-chart  id="engagement" :chart-data="bulbsTakenSnapshot.delivered"></line-chart>
              </div>
            </div>
            <div style=" height:415px; padding-top:18px;">
              <h1 class="admin-snapshot-header">Bulbs Created</h1>
              <div style="padding-top:12px;">
                <line-chart  id="engagement" :chart-data="bulbsCreatedSnapshot.created"></line-chart>
              </div>
            </div>
            <div style=" height:415px; padding-top:18px;" v-if="hasPlaylistAccess">
              <h1 class="admin-snapshot-header">Playlists Created</h1>
              <div style="padding-top:12px;">
                <line-chart  id="engagement" :chart-data="playlistsCreatedSnapshot.created"></line-chart>
              </div>
            </div>
          </div>
        </div>
      </v-layout>
      <v-layout class="admin-data-column" pl-2>
        <div
          style="height: 415px; width: 100%;"
          v-if="!showListData"
        >
          <v-btn
            depressed
            block
            class="full-height"
            color="grey lighten-3"
            @click="getListData"
          >
            <v-layout
              justify-center
              align-center
              column
              py-3
            >
              <v-icon
                :size="64"
              >
                list
              </v-icon>
              <h3
                class="display-1"
              >
                Load list data
              </h3>
            </v-layout>
          </v-btn>
        </div>
        <div style="width: 100%" v-else>
          <v-layout
            style="height:415px; width: 100%"
            v-if="listDataLoading"
            column
          >
            <v-progress-circular indeterminate size=70 :width="5"></v-progress-circular>
            <div class="headline mt-3">Loading list data...</div>
          </v-layout>
          <div style="width: 100%" v-else>
            <div style="height:415px; padding-top:18px;">
              <h1 class="admin-snapshot-header">Most Engaged Classes</h1>
                <v-list two-line>
                  <template v-for="(course, index) in engagementSnapshot.courses">
                    <v-list-tile :key="course.id">
                      <v-list-tile-avatar>
                        <v-icon large :color="(course.default_color) ? course.default_color : '#858585'">folder_shared</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title
                          @click="applyMediaLibFilter(course)"
                          class="branded-text cursor"
                        >
                          {{ course.name }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <span class="text--primary">{{course.engagement_hours.toLocaleString('en')}} engagement hours</span> &mdash; 
                            {{ course.teacherNames.join(', ') }}  
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="index !== (engagementSnapshot.courses.length - 1)" :key="index" :inset=true></v-divider>
                  </template>
              </v-list>
            </div>
            <div style="height:415px; padding-top:18px;">
              <h1 class="admin-snapshot-header">Most Viewed Bulbs</h1>
              <v-list two-line>
                <template v-for="(bulb, index) in bulbsTakenSnapshot.viewed">
                  <v-list-tile :key="bulb.name">
                    <v-list-tile-avatar>
                      <img :src="bulb.thumbnail"></img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="branded-text cursor"  @click="openPreview(bulb)" v-dompurify-html="bulb.name"></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="text--primary">{{bulb.view_count.toLocaleString('en')}} views</span> &mdash; 
                        {{ bulb.teacherNames.join(', ') }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index !== (bulbsTakenSnapshot.viewed.length - 1)" :key="index" :inset=true></v-divider>
                </template>
              </v-list>
            </div>
            <div style=" height:415px; padding-top:18px;">
              <h1 class="admin-snapshot-header">Top Creators</h1>
                <v-list two-line>
                <template v-for="(creator, index) in bulbsCreatedSnapshot.creators">
                  <v-list-tile :key="creator.id">
                    <v-list-tile-avatar>
                      <img :src="creator.picture" v-if="creator.picture">
                      <v-icon large v-if="!creator.picture">account_circle</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="branded-text cursor" @click ="applyMediaLibraryInstructorFilter(creator)" v-dompurify-html="creator.name"></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="text--primary">Bulbs Created: {{creator.bulbs_created.toLocaleString('en')}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index !== (bulbsCreatedSnapshot.creators.length - 1)" :key="index" :inset=true></v-divider>
                </template>
              </v-list>
            </div>
            <div style="height:415px; padding-top:18px;" v-if="hasPlaylistAccess">
              <h1 class="admin-snapshot-header">Most Engaged Playlists</h1>
                <v-list two-line>
                  <template v-for="(playlist, index) in engagementSnapshot.playlists">
                    <v-list-tile :key="playlist.id">
                      <v-list-tile-avatar>
                        <v-icon large :color="(playlist.default_color) ? playlist.default_color : '#858585'">playlist_play</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="black--text">{{playlist.name}}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          <span class="text--primary">{{playlist.engagement_hours.toLocaleString('en')}} engagement hours</span> &mdash; 
                            {{ playlist.teacherNames.join(', ') }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="index !== (engagementSnapshot.playlists.length - 1)" :key="index" :inset=true></v-divider>
                  </template>
              </v-list>
            </div>
          </div>
        </div>
      </v-layout>
    </v-layout>
    <div class="admin-row admin-header">
      <div class="admin-container">
        <h1 class="admin-snapshot-header">Institutional License Details</h1>
        <v-list style="background-color:#fafafa">
          <v-list-tile class="row-between">
            <h4 style="width:50%;">
              {{adminData.hosting ? '*' : ''}}HLS Video Purchased (min):
            </h4>
            <h4 style="width:50%;" v-if="adminData.hosting">
              {{typeof adminData.storageMin === 'string' ? adminData.storageMin : Math.round(adminData.storageMin).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
            </h4>
            <h4 style="width:50%;" v-if="!adminData.hosting">
              Contact PlayPosit to Upgrade
            </h4>
          </v-list-tile>
          <v-list-tile v-if="hostedUsage" class="row-between">
            <h4 style="width:50%;">
              HLS Video Usage (min):
            </h4>
            <h4 style="width:50%;">
              {{Math.round(hostedUsage).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
            </h4>
          </v-list-tile>
          <v-list-tile class="row-between">
            <h4 style="width:50%;">
              PlayPosit Account Manager:
            </h4>
            <h4 style="width:50%;">
              <span v-if="adminData.manager === 'Contact PlayPosit'">{{adminData.manager}}</span>
              <a :href="mailManager" v-if="adminData.manager != 'Contact PlayPosit'">{{adminData.manager}}</a>
            </h4>
          </v-list-tile>
        </v-list>
      </div>
      <div class="admin-container">
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../router';
import { mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import Popover from '../Popover';
import LineChart from '../graphs/LineChart.js';
import BarChart from '../graphs/BarChart.js';
import _ from 'lodash';

export default {
  name: 'admin-snapshot',
  components: {
    Popover,
    LineChart,
    BarChart
  },
  data() {
    return {
      adminFilters: {
        name: [],
        instructor: [],
        subject: [],
        age: [],
        keywords: [],
        course: [],
        organization: [],
        youtube: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'instructorData',
      'branding',
      'dialogShow',
      'popoverToggles',
      'nodeApiPrefix',
      'LTIlaunch',
      'LMSdata',
      'playerApiPrefix',
      'designerApiPrefix',
      'adminData',
    ]),
    ...mapGetters('instructors', [
    'refreshData',
    'activeViewInstructor',
    'queryParamsInstructors',
  ]),
  ...mapState([
    'school',
  ]),
  ...mapState('admin', [
    'hostedUsage',
    'playlistsCreatedSnapshot',
    'showHeaderData',
    'showGraphData',
    'showListData',
  ]),
   ...mapGetters('admin', [
    'activeViewAdmin',
    'adminAjaxing',
    'queryParamsAdmin',
    'schools',
    'bulbs',
    'instructors',
    'selectedDataAdmin',
    'refreshDataAdmin',
    'adminFilterSearch',
    'bulbsCreatedSnapshot',
    'bulbsTakenSnapshot',
    'engagementSnapshot',
    'graphDataLoading',
    'listDataLoading',
    'snapshotsettings',
    'headerData',
    'headerDataLoading',
  ]),
  hasPlaylistAccess() {
    return _.get(this.school, 'config.permissions', []).includes('hasPlaylistAccess');
  },
    mailManager: function(){
      return `mailto:${this.adminData.managerEmail}`
    }
  },
  methods:{
  ...mapActions('admin', [
    'getSnapshotHeaderData',
    'getSnapshotGraphData',
    'getSnapshotListData',
    'getHostedUsage',
  ]),
  ...mapMutations('admin', [
    'updateShowHeaderData',
    'updateShowGraphData',
    'updateShowListData',
  ]),
  ...mapMutations([
    'handleDialogOpen',
  ]),
  getHeaderData() {
    this.updateShowHeaderData(true);
    this.getSnapshotHeaderData();
  },
  getGraphData() {
    this.updateShowGraphData(true);
    this.getSnapshotGraphData();
  },
  getListData() {
    this.updateShowListData(true);
    this.getSnapshotListData();
  },
    //run at mount
    getData: function(){
      this.$store.commit('admin/setSnapshotFilterDate',this.adminData);
    },
    openPreview: function(bulb){
      //opens player
      window.open(`/player_v2/?type=share&bulb_id=${bulb.id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
    },
    applyMediaLibFilter: async function(course){
      const obj = {
        creator: {},
        name: this.adminFilters.name,
        instructor: this.adminFilters.instructor,
        subject: this.adminFilters.subject,
        age: this.adminFilters.age,
        keywords: this.adminFilters.keywords,
        organization: this.adminFilters.organization,
        course: this.adminFilters.course,
        youtube: this.adminFilters.youtube,
      }
      const filterCourse = {
        name : course.name,
        id : course.id
      }
      obj.course = [filterCourse];
      this.$store.commit('admin/setActiveView', ["Bulbs"]);
      this.$store.commit('admin/setQueryParams', {sort:'', page:1, per_page:20});
      this.$store.dispatch('admin/updateUrl');
      this.$store.commit('admin/setAdminFilters', obj);
      this.$store.commit('admin/refreshComplete');
    },
    applyMediaLibraryInstructorFilter: async function(creator){
      this.$store.commit('admin/setActiveView', ["Bulbs"]);
      this.$store.commit('admin/setQueryParams', {sort:'', page:1, per_page:20});
      this.$store.dispatch('admin/updateUrl');
      const obj = {...this.adminFilters};
      obj.creator = { 'id': creator.id, 'name': creator.name };
      this.$store.commit('admin/setAdminFilters', obj);
      this.$store.commit('admin/refreshComplete');
    },
  },
  watch: {

    modalOpen: {
      handler: function(val){
        //close table popovers from hotlinks
        if(val){
          this.popoverReset = false;
          setTimeout(() => {this.popoverReset = true}, .0000001);
        }
      }
    },
  },
  beforeMount() {
    this.getHostedUsage();
  },
  mounted() {
    this.getData();
  },
  beforeDestroy(){
  }
};
</script>

<style scoped>
#admin-snapshot{
  height: calc(100vh - 100px);
  min-width:1000px;
  overflow-y: scroll;
}

.v-btn.no-height-limit {
  height: auto !important;
}

.admin-data-column {
  width: 50%;
}


.admin-preview-btn {
  font: bold 10px; 
  color: #0062ff;
  cursor: pointer;
}
.admin-view-class {
  cursor: pointer;
  font: bold 10px; 
  color: #0062ff;
}
.admin-list-data-item.el-tag {
  background-color: #fff;
  border-color: #eaeaea;
  border-radius: 15px;
  display: inline;
  line-height: 0px;
}
</style>


